const OLDEST_YEAR = 2017
export const NEWEST_YEAR = new Date().getFullYear()
export const YEARS_FROM: (oldestYear: number) => number[] = (oldestYear = OLDEST_YEAR) => {
  return Array.from({ length: NEWEST_YEAR - oldestYear + 1 }, (_, i) => oldestYear + i).reverse()
}
